export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "NU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "NU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "PU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "PU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "PU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "PU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
	},
	pikachu: {
		tier: "LC",
	},
	raichu: {
		tier: "NUBL",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "PU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "PU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "NU",
	},
	clefairy: {
		tier: "LC",
	},
	clefable: {
		tier: "NU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "NU",
	},
	jigglypuff: {
		tier: "LC",
	},
	wigglytuff: {
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "PU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "PU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "PU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "NUBL",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "PU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "PU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NUBL",
	},
	poliwrath: {
		tier: "NUBL",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "UU",
	},
	alakazam: {
		tier: "OU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "PU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "NU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "PU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "OU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "PU",
	},
	farfetchd: {
		tier: "PU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "UU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "PU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "UU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "PU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "NU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "PU",
	},
	exeggcute: {
		tier: "NU",
	},
	exeggutor: {
		tier: "OU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "PU",
	},
	hitmonlee: {
		tier: "PU",
	},
	hitmonchan: {
		tier: "PU",
	},
	lickitung: {
		tier: "PU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "PU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
	},
	chansey: {
		tier: "OU",
	},
	tangela: {
		tier: "UU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "PU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "NU",
	},
	scyther: {
		tier: "PU",
	},
	jynx: {
		tier: "OU",
	},
	electabuzz: {
		tier: "UU",
	},
	magmar: {
		tier: "PU",
	},
	pinsir: {
		tier: "PU",
	},
	tauros: {
		tier: "OU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
	},
	lapras: {
		tier: "UU",
	},
	ditto: {
		tier: "PU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "UU",
	},
	jolteon: {
		tier: "OU",
	},
	flareon: {
		tier: "PU",
	},
	porygon: {
		tier: "NU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "NU",
	},
	aerodactyl: {
		tier: "UU",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UU",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "NU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "UU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	missingno: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
};
